module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/history-item-divider.8737d7d1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/history-item-divider.png
// module id = 2838
// module chunks = 11